import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';
import ErrorBoundary from './components/ErrorBoundary';

// Use environment variables for PostHog configuration
const posthogKey = import.meta.env.VITE_REACT_APP_POSTHOG_KEY || 'phc_default_key';
const posthogHost = import.meta.env.VITE_REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={posthogKey} 
      apiHost={posthogHost} 
      capturePageView={false} 
      capturePageLeave={true} 
      autocapture={{
        // Restrict autocapture to only elements with specific data attribute
        // This gives more control over what interactions are tracked
        dom_event_allowlist: ['click', 'submit'],
        css_selector_allowlist: ['[data-ph-capture]'] 
      }}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>
);